import { Injectable } from '@angular/core';
import { AuthService } from 'projects/shared/src/lib/authentication/auth.service';
import { Message } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AutoSaveService {
  readonly TimeOutMilliSeconds = 5000;

  readonly DataRestoredMsg: Message = {
    severity: 'info',
    summary: 'Form Data Restored',
    detail: 'Your previous form entry has been restored.'
  };

  readonly DataSavedMsg: Message = {
    severity: 'info',
    summary: 'Form Data Saved',
    detail: 'We have saved your entry and will restore it when you return to the form.'
  };

  readonly AutoSavedDataRemovedMsg: Message = {
    severity: 'info',
    summary: 'Saved Form Data Removed',
    detail: 'Your saved form entry has been removed.'
  };

  username: string;

  constructor(private authService: AuthService) {
    this.authService.getUsername().subscribe(user => {
        this.username = user ?? '';
    });
  }

  SetItem<T>(pageName: string, formDataName: string, formValue: T): void {
    const localStorageKey = `${this.username}_${pageName}_${formDataName}`;
    localStorage.setItem(localStorageKey, JSON.stringify(formValue));
  }

  GetItem<T>(pageName: string, formDataName: string): T | undefined {
    const localStorageKey = `${this.username}_${pageName}_${formDataName}`;
    const formValue = localStorage.getItem(localStorageKey);

    if (formValue) {
      return JSON.parse(formValue);
    }
  }

  RemoveItem(pageName: string, formDataName: string): void {
    const localStorageKey = `${this.username}_${pageName}_${formDataName}`;
    localStorage.removeItem(localStorageKey);
  }
}
